var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"astra",style:(_vm.astraStyle),attrs:{"id":"sun","src":_vm.astraSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }